import React from "react"

import styles from "./Tab.module.scss"

/**
 *
 * @param {String} [className] - additional className to add
 * @param {String} heading - tab heading to show
 * @param {String} description - description underneath the heading
 * @param {String} icon - fa icon class
 * @param {Boolean} active - whether the tab is active
 * @param {Function} onClick - event handler to toggle tab as active
 */
const Tab = props => {
    return (
        <div
            className={`${styles.tab} ${props.className || ""} ${props.active ? styles.active : ""}`}
            onClick={props.onClick || null}
        >
            <i
                className={`${props.icon || "fal fa-copy"} ${styles["tab-icon"]}`}
            />
            <div className={styles["tab-info"]}>
                <span className={styles["tab-heading"]}>
                    {props.heading || "Description"}
                    {props.count && <span> ({props.count})</span>}
                </span>
                <span className={styles["tab-description"]}>
                    {props.description || ""}
                </span>
            </div>
        </div>
    )
}

export default Tab
